import RFQLinesForm from '../../../../components/Purchasing/RFQ/Lines/RFQLinesForm'
import React from 'react'
import { Modal } from 'antd'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'

function RFQLinesModal(props) {
  const {
    remove,
    submit,
    update,
    visible,
    modalType,
    formRef,
    onCancel,
    removing,
    submitting,
    isUpdatable,
  } = props
  const isNew = modalType === 'new'
  return (
    <Modal
      visible={visible}
      title={'DWG Lines'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          visible={isUpdatable}
          submit={submit}
          remove={remove}
          update={update}
          removing={removing}
          submitting={submitting}
          title={'Lines'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <RFQLinesForm ref={formRef} {...props} />
    </Modal>
  )
}

RFQLinesModal.propTypes = {}
RFQLinesModal.defaultProps = {}

export default RFQLinesModal
